import { isMobile } from "react-device-detect";
import { UserNotification, eNotificationRead } from "../../../@types/Users";
import { Button } from "react-bootstrap";
import { AiOutlineDelete } from "react-icons/ai";
import moment from "moment";
import { projectPrimaryColor } from "../../../generalConfigs";
import useNotifications from "../../../hooks/useNotification";
import { Dispatch, SetStateAction, useEffect } from "react";
import Swal from "sweetalert2";

type Props = {
    notification: UserNotification,
    handleCloseDropdown: CallableFunction,
    setParentNotificationState: Dispatch<SetStateAction<UserNotification[]>>
}
export function ViewOne({ notification, handleCloseDropdown, setParentNotificationState }: Props) {
    const { markRead, moveToJunk } = useNotifications();

    /**
     * Determines if a notification is't read and send a call to api to mark as read
     * in the end change parent state to show a correct read status icon
     */
    async function handleReadNotification() {
        const notificationStatus = notification.is_read;

        if (notificationStatus === eNotificationRead.NOT_READ) {
            const isMarkedAsRead = await markRead(notification.id);

            if (isMarkedAsRead) {
                setParentNotificationState((old) => old.map((notif) => {
                    if (notif.id === notification.id) {
                        notif.is_read = eNotificationRead.READ;
                    }

                    return notif;
                }))
            }
        }
    }

    useEffect(() => {
        handleReadNotification();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notification])

    /**
   * Deletes a notification and change parent state
   */
    async function handleDeleteNotification() {
        Swal.fire({
            title: "Tem certeza?",
            text: "Essa ação não pode ser revertida.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: projectPrimaryColor,
            cancelButtonColor: "gray",
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
            background: "var(--bg-1)",
            color: "var(--text-1)",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const isMovedToJunk = await moveToJunk(notification.id);

                if (isMovedToJunk) {
                    handleCloseDropdown();
                    setParentNotificationState((old) => old.filter((notif) => notif.id !== notification.id))
                }
            }
        })
    }

    const date = moment(notification.created_at).format('DD/MM/YYYY [às] HH:mm:ss')
    return (
        <div className="dropdown-menu no-clicable-action" style={!isMobile ? { overflowY: 'auto', maxHeight: '80vh' } : {}}>
            <div className="az-dropdown-header mg-b-10 no-clicable-action d-flex position-relative">
                <i className="icon ion-md-arrow-back cursor-pointer" style={{ fontSize: 27, color: 'var(--text-1)' }} onClick={() => handleCloseDropdown()}>
                </i>

                <div className="cursor-pointer mg-t-8" style={{ position: 'absolute', right: 0 }} onClick={handleDeleteNotification}>
                    <AiOutlineDelete size={23} className="horevedDanger" />
                </div>
            </div>

            <h6 className="az-notification-title">{notification?.title}</h6>
            <span className="tx-11 mg-b-10">
                Recebido em: {date}
            </span>

            <p className="tx-14 text-start mg-t-10">
                {notification?.description}
            </p>

            <ActionButton url={notification?.action_url} />



        </div >
    );
}

type ActionButtonProps = {
    url: string | undefined
}
function ActionButton({ url }: ActionButtonProps) {
    if (!url) {
        return <></>
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
            <Button style={{ borderRadius: 15, backgroundColor: projectPrimaryColor }} href={url} target="_blank">
                Acessar o link
            </Button>
        </div>
    )
}